/* eslint-disable import/prefer-default-export */

import { actions as onionActions } from 'onion-form';

import * as api from '../../../common/api';

export function submitForm({ values: { email, password } }) {
  return (dispatch) => {
    const promise = async () => {
      const response = await api.post(
        '/session',
        { user: { email, password } },
        { credentials: 'include' }
      );

      if (response.status >= 400) {
        dispatch(onionActions.clearForm('signIn'));
      }

      const { location } = await response.json();

      window.location = location;
    };

    return dispatch({
      type: 'SUBMIT_LOGIN_FORM',
      payload: promise()
    })
    .catch(() => null);
  };
}



// WEBPACK FOOTER //
// ./src/browser/Feature/login/actions.js